import * as React from 'react';
//Icons import
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

interface ExpandIconProps {
    isExpanded: boolean;
}

const ExpandIcon = (props: ExpandIconProps) => {
    return !props.isExpanded ? <AddIcon /> : <RemoveIcon />;
};

export default ExpandIcon;
